import React, {ReactNode} from "react";
import {Colors, Container, Text} from "@bounce/shared/ui";
import {Card} from "../../../../../../../bounce-ui/backoffice";

interface IKeyValueRow {
  field: string;
  title?: boolean;
  children: ReactNode;
}

export const StyledCard = ({children}: {children: ReactNode}) => {
  return <Card sx={{width: "690px", padding: "20px"}}>{children}</Card>;
};

export const KeyValueRow = ({field, title = false, children}: IKeyValueRow) => {
  return (
    <Container row fullWidth sx={{justifyContent: "space-between"}}>
      <Text
        variant={title ? "interDisplay800" : "interDisplay400"}
        sx={{color: title ? Colors.grey._1000 : Colors.grey._700, whiteSpace: "nowrap"}}
      >
        {field}
      </Text>
      {children}
    </Container>
  );
};
